import {observer} from "mobx-react";
import {ScaFormProps} from "./commons";
import {FieldInput, FieldSelect, FormSection} from "../../ui";
import {convertDocumentType, convertScaDocumentStatus} from "../../../api";
import {AcquisitionDocumentDto, AcquisitionDocumentStatusDto} from "../../../api/sca";

const statusOptions = Object.keys(AcquisitionDocumentStatusDto).map(e => ({
    value: e,
    label: convertScaDocumentStatus(e as AcquisitionDocumentStatusDto)
}))

const ScaDocumentsForm = observer(function ScaDocumentsForm({
                                                                disabled,
                                                                validation,
                                                                value,
                                                                onChange,
                                                                onBlur
                                                            }: ScaFormProps) {
    function updateDocumentStatus(doc: AcquisitionDocumentDto, status: AcquisitionDocumentStatusDto) {
        const documents: AcquisitionDocumentDto[] = value.documents.map(d => {
            if (d.documentId !== doc.documentId) {
                return d
            }
            return {
                ...d,
                status
            }
        })
        onChange({
            ...value,
            documents
        })
    }

    return <>
        <div style={{overflow: 'visible', padding: '1em'}}>
            {value.documents.map((doc, index) => {
                const securityCodeValidation = (validation?.securityCodes || [])[index]
                return (<FormSection
                    key={doc.type}
                    label={`${convertDocumentType(doc.type)}`}
                    children={
                        <div className={"columns"}>
                            <div className={"column"}>
                                <FieldInput
                                    disabled={(disabled ||
                                        doc.status === AcquisitionDocumentStatusDto.ERROR_NO_CODE ||
                                        doc.status === AcquisitionDocumentStatusDto.ERROR_NOT_READABLE) && (
                                        doc.sourceStatus !== AcquisitionDocumentStatusDto.CODE_INVALID
                                    )}
                                    label={"Sicherheitscode"}
                                    value={doc.securityCode || ''}
                                    onBlur={() => onBlur()}
                                    invalid={Boolean(securityCodeValidation) || doc.sourceStatus === AcquisitionDocumentStatusDto.CODE_INVALID}
                                    help={securityCodeValidation}
                                    onChange={v => {
                                        const documents: AcquisitionDocumentDto[] = value.documents.map(d => {
                                            if (d.documentId !== doc.documentId) {
                                                return d
                                            }
                                            return {
                                                ...d,
                                                status: AcquisitionDocumentStatusDto.READ,
                                                securityCode: v
                                            }
                                        })
                                        onChange({
                                            ...value,
                                            documents
                                        })
                                    }}
                                />
                            </div>
                            <div className={"column"}>
                                <FieldInput
                                    label={"Dokumenten-Id"}
                                    value={doc.documentId || ''}
                                    disabled={true}
                                />
                            </div>
                            <div className={"column"}>
                                <FieldInput
                                    label={"Nummer"}
                                    value={doc.serialNumber || ''}
                                    disabled={true}
                                />
                            </div>
                            <div className={"column"}>
                                <FieldSelect
                                    disabled={disabled}
                                    options={statusOptions}
                                    label={"Status"}
                                    value={doc.status || AcquisitionDocumentStatusDto.INITIALIZED}
                                    onChange={e => {
                                        const original = doc.status || AcquisitionDocumentStatusDto.INITIALIZED
                                        const updated = e as AcquisitionDocumentStatusDto
                                        updateDocumentStatus(doc, updated === AcquisitionDocumentStatusDto.CODE_INVALID ? original : updated)
                                        onBlur()
                                    }}
                                />
                            </div>
                        </div>
                    }
                />)
            })}
        </div>
    </>
})

export {
    ScaDocumentsForm
}
